export const getAllSureMotorClaim = (state) => state.allSureMotorClaim;
